(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productheader"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Image Gallery Functionality
  let currentImageIndex = 0;
  const thumbnails = Array.from(document.querySelectorAll('.thumbnail'));
  const mainImage = document.getElementById('mainProductImage');
  
  function updateMainImage(index) {
    // Update active thumbnail
    thumbnails.forEach(thumb => thumb.classList.remove('active'));
    thumbnails[index].classList.add('active');
    
    // Update main image
    const newSrc = thumbnails[index].dataset.fullsize;
    mainImage.src = newSrc;
    mainImage.classList.remove('zoomed');
    
    // Update current index
    currentImageIndex = index;
  }
  
  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', function() {
      updateMainImage(index);
    });
  });
  
  // Arrow navigation
  document.querySelector('.prev-arrow')?.addEventListener('click', function() {
    let prevIndex = currentImageIndex - 1;
    if (prevIndex < 0) prevIndex = thumbnails.length - 1;
    updateMainImage(prevIndex);
  });
  
  document.querySelector('.next-arrow')?.addEventListener('click', function() {
    let nextIndex = currentImageIndex + 1;
    if (nextIndex >= thumbnails.length) nextIndex = 0;
    updateMainImage(nextIndex);
  });
  
  // Image zoom functionality
  if (mainImage) {
    mainImage.addEventListener('click', function() {
      this.classList.toggle('zoomed');
    });
  }
  
  // Quantity Selector
  document.querySelector('.qty-btn.minus')?.addEventListener('click', function() {
    const input = document.querySelector('.qty-input');
    if (parseInt(input.value) > 1) {
      input.value = parseInt(input.value) - 1;
    }
  });
  
  document.querySelector('.qty-btn.plus')?.addEventListener('click', function() {
    const input = document.querySelector('.qty-input');
    input.value = parseInt(input.value) + 1;
  });
  
  // Color Swatch Selection
  document.querySelectorAll('.swatch').forEach(swatch => {
    swatch.addEventListener('click', function() {
      document.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
      this.classList.add('active');
      document.querySelector('input[name="id"]').value = this.dataset.variantId;
    });
  });
  
  // Cart Drawer Elements
  const cartDrawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.overlay');
  const closeCartBtn = document.querySelector('.close-cart');
  const cartIcon = document.querySelector('.cart-icon');
  
  // Toggle cart drawer
  function toggleCart() {
    cartDrawer.classList.toggle('active');
    overlay.classList.toggle('active');
    document.body.classList.toggle('no-scroll');
  }
  
  // Event listeners for cart
  if (cartIcon) cartIcon.addEventListener('click', toggleCart);
  if (closeCartBtn) closeCartBtn.addEventListener('click', toggleCart);
  if (overlay) overlay.addEventListener('click', toggleCart);
  
  // Show notification
  function showNotification(message) {
    const notification = document.createElement('div');
    notification.className = 'notification';
    notification.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
      ${message}
    `;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.add('show');
    }, 10);
    
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }
  
  // Update cart count in header
  function updateCartCount(count) {
    const cartCountEl = document.querySelector('.cart-count');
    if (cartCountEl) {
      cartCountEl.textContent = count;
    }
  }
  
  function renderCartItems(cart) {
    const cartItemsEl = document.querySelector('.cart-items');
    const cartTotalEl = document.querySelector('.cart-total-price');
    
    if (!cartItemsEl) return;
    
    // Clear existing items
    cartItemsEl.innerHTML = '';
    
    // Add new items with formatted prices
    cart.items.forEach(item => {
      const itemEl = document.createElement('div');
      itemEl.className = 'cart-item';
      itemEl.innerHTML = `
        <img src="${item.image}" alt="${item.title}" class="cart-item-image">
        <div class="cart-item-details">
          <div class="cart-item-title">${item.title}</div>
          <div class="cart-item-price">${Shopify.formatMoney(item.price)}</div>
          <div>Quantity: ${item.quantity}</div>
        </div>
      `;
      cartItemsEl.appendChild(itemEl);
    });
    
    // Update total with formatted money
    if (cartTotalEl) {
      cartTotalEl.textContent = Shopify.formatMoney(cart.total_price);
    }
  }
  
  document.querySelector('.btn-add-to-cart')?.addEventListener('click', function(e) {
    e.preventDefault();
    const form = document.getElementById('product-form');
    const quantityInput = document.querySelector('.qty-input');
    const variantId = form.querySelector('input[name="id"]').value;
    
    // Update quantity in form before submitting
    form.querySelector('input[name="quantity"]').value = quantityInput.value;
    
    // Create form data
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantityInput.value);
    
    // Add to cart
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      // Show success notification with formatted price
      const price = Shopify.formatMoney(data.price * data.quantity);
      showNotification('Product toegevoegd aan winkelwagen! ' + price);
      
      // Update cart count
      updateCartCount(data.item_count);
      
      // Open cart drawer
      toggleCart();
      
      // Update cart contents
      return fetch('/cart.js');
    })
    .then(response => response.json())
    .then(cart => {
      renderCartItems(cart);
    })
    .catch(error => {
      console.error('Error:', error);
      showNotification('Item toegevoegd aan winkelwagen!');
    });
  });
  
  // Initialize cart on page load
  function initCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        renderCartItems(cart);
      });
  }
  
  // Initialize cart
  initCart();
});

  } catch(e) { console.error(e); }
})();
})();
